import { gql } from '../../../__generated__';

export const GET_FLOOR_PLAN_DATA = gql(`
  query GetFloorPlanWeb($floorPlanId: ID) {
  getFloorPlanWeb(floorPlanId: $floorPlanId) {
    id
    name
    propertyType
    status
    floorNumber
    assets {
      angle
      category
      direction
      height
      id
      key
      width
    }
    annotation {
      detections {
        bbox
        childID
        childType
        confidence
        parentID
        parentType
        title
      }
      parentTypes {
        parentID
        parentType
        title
        bbox
      }
    }
  }
}
`);

export const GET_AREA_TYPES = gql(`
  query Data {
  getFloorPlanStaticDataWeb {
    data {
      allowedChildrenElements
      allowedParentElements
      description
      title
      type
    }
  }
}`);
